import { LineOrientation } from './Line';

const HORIZONTAL_DIRECTION_OPTIONS = ['to-right', 'to-left'] as const;

const VERTICAL_DIRECTION_OPTIONS = ['to-top', 'to-bottom'] as const;

const SIZE_CONFIG = {
  from: 50,
  to: 700,
};

const SCALE_MIN = 0.45;

const DURATION_CONFIG = {
  from: 30,
  to: 50,
};

const DELAY_CONFIG = {
  from: 0,
  to: 50,
};

function getRandomInt(config: { from: number; to: number }): number {
  return (
    Math.floor(Math.random() * (config.to - config.from + 1)) + config.from
  );
}

export type IdleAnimationConfig = {
  direction:
    | (typeof HORIZONTAL_DIRECTION_OPTIONS)[number]
    | (typeof VERTICAL_DIRECTION_OPTIONS)[number];
  size: number;
  fromScale: string;
  toScale: string;
  fromTranslate: string;
  toTranslate: string;
  duration: number;
  delay: number;
};

export function getIdleAnimationConfig(
  orientation: LineOrientation,
): IdleAnimationConfig {
  const direction = (
    orientation === 'horizontal'
      ? HORIZONTAL_DIRECTION_OPTIONS
      : VERTICAL_DIRECTION_OPTIONS
  )[getRandomInt({ from: 0, to: 1 })];

  const isSizeGrowing = Boolean(getRandomInt({ from: 0, to: 1 }));

  let fromTranslate, toTranslate;
  switch (direction) {
    case 'to-right':
      fromTranslate = '-100%';
      toTranslate = 'var(--container-width)';
      break;
    case 'to-left':
      fromTranslate = 'var(--container-width)';
      toTranslate = '-100%';
      break;
    case 'to-top':
      fromTranslate = 'var(--container-height)';
      toTranslate = '-100%';
      break;
    case 'to-bottom':
      fromTranslate = '-100%';
      toTranslate = 'var(--container-height)';
      break;
  }

  return {
    direction,
    size: getRandomInt(SIZE_CONFIG),
    fromScale: isSizeGrowing ? `${SCALE_MIN}` : '1',
    toScale: isSizeGrowing ? '1' : `${SCALE_MIN}`,
    fromTranslate,
    toTranslate,
    duration: getRandomInt(DURATION_CONFIG),
    delay: getRandomInt(DELAY_CONFIG),
  };
}
